import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension, CustomFieldExtensionSchema } from '@backstage/plugin-scaffolder-react';
import { Sev2TaskCombobox, Sev2TaskComboboxSchema } from './Sev2TaskCombobox';

export const Sev2TaskComboboxFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'Sev2TaskCombobox',
    component: Sev2TaskCombobox,
    schema: Sev2TaskComboboxSchema as CustomFieldExtensionSchema,
  }),
);
